import {
	DdiziStatusTypeArray,
	DdiziStatusTypeLabel,
	DdiziType,
} from '@kinderlabs-pos/shared-data-type';
import { WithDialog, XlDialogProps } from '@kinderlabs-pos/ui-atoms';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import React from 'react';
import { FilterWith전체Selector } from '../../composites/FilterWithAllSelector';
import { PosFilterSelector } from '../../composites/PosFilterSelector';

export type DdiziFilterType = {
	targetPosId?: number;
	status?: DdiziType['status'];
};
export interface IDdiziFilterDialogProps extends XlDialogProps {
	filter: DdiziFilterType;
	setFilter: React.Dispatch<React.SetStateAction<DdiziFilterType>>;
}
export const DdiziFilterDialog: React.FC<IDdiziFilterDialogProps> = ({
	open,
	closeDialog,
	filter,
	setFilter,
}) => {
	const [tempFilter, setTempFilter] = React.useState(filter);

	return (
		<WithDialog.XlDialog
			scroll='paper'
			open={open}
			closeDialog={closeDialog}>
			<DialogTitle>티켓 필터</DialogTitle>
			<DialogContent>
				<Stack
					direction={'row'}
					spacing={1}>
					<Box
						width={180}
						py={1}>
						<FilterWith전체Selector
							label={'티켓 상태'}
							candidates={DdiziStatusTypeArray.map((ddiziType) => ({
								label: DdiziStatusTypeLabel[ddiziType],
								value: ddiziType,
							}))}
							value={tempFilter.status}
							onChangeValue={(value) => {
								// @ts-ignore // 아 select 들 type 짜증나...
								setTempFilter((prev) => ({ ...prev, status: value }));
							}}
						/>
					</Box>
					<Box
						width={180}
						py={1}>
						<PosFilterSelector
							targetPosId={tempFilter.targetPosId}
							onChangeValue={(val) => {
								setTempFilter((state) => ({
									...state,
									targetPosId: val ? +val : undefined,
								}));
							}}
						/>
					</Box>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button
					variant={'contained'}
					onClick={() => {
						setFilter(tempFilter);
						closeDialog && closeDialog();
					}}>
					확인
				</Button>
				<Button
					onClick={closeDialog}
					variant={'outlined'}>
					취소
				</Button>
			</DialogActions>
		</WithDialog.XlDialog>
	);
};
